/**
 * 员工（系统用户）下拉数据源（物业模块通用）
 * 用于将手填员工 ID / 用户 ID 替换为下拉选择。
 */
import * as UserApi from '@/api/system/user'

export function useStaff() {
  const staffOptions = ref<{ value: number; label: string; deptId?: number }[]>([])
  const staffMap = ref<Record<number, string>>({})

  async function loadStaffs(): Promise<void> {
    try {
      const list = (await UserApi.getSimpleUserList()) || []
      staffOptions.value = list.map((u) => ({
        value: u.id,
        label: u.nickname || u.username || String(u.id),
        deptId: u.deptId
      }))
      const map: Record<number, string> = {}
      list.forEach((u) => {
        map[u.id] = u.nickname || u.username || String(u.id)
      })
      staffMap.value = map
    } catch {
      staffOptions.value = []
      staffMap.value = {}
    }
  }

  return { staffOptions, staffMap, loadStaffs }
}
